"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../../analytics-subjects");
var CardWithImage_1 = require("../../../../../components/CardWithImage");
var copy_1 = require("../../../../../copy");
var images_1 = require("../../../../../images");
var sandwich_ids_1 = require("../../../../../sandwich-ids");
var section_ids_1 = require("../../../../../section-ids");
exports.Error = (0, react_1.memo)(function () {
    var _a;
    var Heading3 = (0, core_1.useComponents)().Heading3;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.BILLING_SUMMARY, properties: (_a = {
                errorId: section_ids_1.BILLING_SUMMARY_ERROR,
                alertLevel: 'warn',
                status: 'error'
            },
            _a[core_1.INTERNAL_EVENT_FLAG] = true,
            _a) },
        react_1.default.createElement(CardWithImage_1.CardWithImage, { Image: react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.summary.error },
                react_1.default.createElement(images_1.NoDataImage, { "data-testid": section_ids_1.BILLING_SUMMARY_ERROR })) },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Heading3, null,
                    react_1.default.createElement(Copy, { copyKey: "billingSummaryTitle" })),
                react_1.default.createElement(Copy, { copyKey: "noData" })),
            react_1.default.createElement(Copy, { copyKey: "helpCentre" }))));
});
